import React from 'react';

import { ScreenTitle } from '../../../../components/atoms';
import './style.scss';

const TestSpeed = () => {
  return (
    <>
      <ScreenTitle title='Dashboard' subTitle='Test Internet Speed'/>
      <div>
        {' '}
        <iframe
          src='https://fast.com/'
          className='iframe'
          title='Iframe Example'
          style={{ border: 0 }}
        ></iframe>
      </div>
    </>
  );
};

export default TestSpeed;
